import { useCountUp } from '../useCountUp'

export function RouteVisual() {
	const groups = [
		{ y: 88, label: 'Transición al encargo', topics: 3 },
		{ y: 168, label: 'Fases del proyecto', topics: 4 },
		{ y: 248, label: 'Gestión de tiempos', topics: 3 },
		{ y: 328, label: 'Cliente y comunicación', topics: 4 },
	]

	const targetProgress = 78
	const progress = useCountUp(targetProgress, 1800)
	const barTotalHeight = 260
	const barFillHeight = (barTotalHeight * progress) / 100

	return (
		<svg
			viewBox="0 0 560 420"
			className="h-full w-full"
			role="img"
			aria-label="Ruta: gestionar un proyecto sin equipo"
			style={{ color: 'var(--gold-text)' }}
		>
			<text
				x="280"
				y="30"
				textAnchor="middle"
				fontSize="12"
				fill="rgba(255,255,255,0.42)"
				fontFamily="ui-monospace, SFMono-Regular, monospace"
				letterSpacing="2"
			>
				RUTA · GESTIONAR UN PROYECTO SIN EQUIPO
			</text>

			<circle cx="200" cy="58" r="6" fill="currentColor" fillOpacity="0.55">
				<animate
					attributeName="r"
					values="5;7;5"
					dur="2.2s"
					repeatCount="indefinite"
				/>
			</circle>
			<text x="214" y="62" fontSize="12" fill="rgba(255,255,255,0.55)">
				Inicio
			</text>

			<line
				x1="200"
				y1="66"
				x2="200"
				y2="370"
				stroke="currentColor"
				strokeWidth="1.8"
				strokeOpacity="0.32"
			/>

			{groups.map((group, groupIndex) => (
				<g key={group.label}>
					<circle
						cx="200"
						cy={group.y}
						r="8"
						fill="none"
						stroke="currentColor"
						strokeWidth="1.6"
						strokeOpacity="0.7"
					/>
					<circle
						cx="200"
						cy={group.y}
						r="3.5"
						fill="currentColor"
						fillOpacity="0.5"
					/>
					<text
						x="184"
						y={group.y + 4}
						textAnchor="end"
						fontSize="13"
						fill="rgba(255,255,255,0.68)"
					>
						{group.label}
					</text>
					<line
						x1="208"
						y1={group.y}
						x2="288"
						y2={group.y}
						stroke="currentColor"
						strokeWidth="1"
						strokeOpacity="0.2"
					/>

					{Array.from({ length: group.topics }).map((_, topicIndex) => {
						const angle = (topicIndex / group.topics) * Math.PI * 1.6 - 0.5
						const radius = 26 + (topicIndex % 2) * 14
						const tx = 322 + Math.cos(angle) * radius
						const ty = group.y + Math.sin(angle) * radius * 0.8

						return (
							<g key={`${group.label}-${topicIndex}`}>
								<line
									x1="322"
									y1={group.y}
									x2={tx}
									y2={ty}
									stroke="currentColor"
									strokeWidth="0.5"
									strokeOpacity="0.14"
								/>
								<circle
									cx={tx}
									cy={ty}
									r="4"
									fill="currentColor"
									fillOpacity={0.18 + topicIndex * 0.07}
								>
									<animate
										attributeName="fillOpacity"
										values={`${0.18 + topicIndex * 0.07};${0.4 + topicIndex * 0.07};${0.18 + topicIndex * 0.07}`}
										dur={`${2.1 + topicIndex * 0.25}s`}
										begin={`${groupIndex * 0.2}s`}
										repeatCount="indefinite"
									/>
								</circle>
							</g>
						)
					})}

					<circle
						cx="322"
						cy={group.y}
						r="6"
						fill="none"
						stroke="currentColor"
						strokeWidth="0.8"
						strokeOpacity="0.22"
					/>
					<text
						x="400"
						y={group.y + 4}
						fontSize="12"
						fill="rgba(255,255,255,0.38)"
						fontFamily="ui-monospace, SFMono-Regular, monospace"
					>
						{group.topics} temas
					</text>
				</g>
			))}

			<rect
				x="500"
				y="90"
				width="5"
				height={barTotalHeight}
				rx="2.5"
				fill="rgba(255,255,255,0.06)"
			/>
			<rect
				x="500"
				y="90"
				width="5"
				height={barFillHeight}
				rx="2.5"
				fill="currentColor"
				fillOpacity="0.55"
			/>
			<text
				x="512"
				y="225"
				fontSize="12"
				fill="rgba(255,255,255,0.45)"
				fontFamily="ui-monospace, SFMono-Regular, monospace"
			>
				{Math.round(progress)}%
			</text>

			<text
				x="280"
				y="398"
				textAnchor="middle"
				fontSize="12"
				fill="rgba(255,255,255,0.38)"
			>
				14 temas · progreso propio · criterio acumulable
			</text>
		</svg>
	)
}
